const PRODUCT = 'product';
const SUBSCRIPTION = 'subscription';

export {
  PRODUCT,
  SUBSCRIPTION,
};
